/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import Tilt from "react-tilt";
import "./Services.css";
import { Fade } from "react-reveal";

export default function Services() {
  return (
    <div id="services">
      <div className="servicesSec container-fluid">
        <Fade bottom>
          <div className="servicesCard">
            <h3>خدماتنا</h3>
            <div className="services">
              <div className="row">
                <div className="col-lg-3 col-md-6 my-3">
                  <Tilt
                    className="Tilt"
                    options={{
                      max: 45,
                      scale: 1,
                      transition: true,
                    }}
                  >
                    <div className="cardText img1">
                      <p>التقييم العقاري</p>
                    </div>
                  </Tilt>
                </div>
                <div className="col-lg-3 col-md-6 my-3">
                  <Tilt
                    className="Tilt"
                    options={{
                      max: 45,
                      scale: 1,
                      transition: true,
                    }}
                  >
                    <div className="cardText img2">
                      <p>تقييم الالآت والمعدات</p>
                    </div>
                  </Tilt>
                </div>
                <div className="col-lg-3 col-md-6 my-3">
                  <Tilt
                    className="Tilt"
                    options={{
                      max: 45,
                      scale: 1,
                      transition: true,
                    }}
                  >
                    <div className="cardText img3">
                      <p>مؤشرات السوق العقاري</p>
                    </div>
                  </Tilt>
                </div>
                <div className="col-lg-3 col-md-6 my-3">
                  <Tilt
                    className="Tilt"
                    options={{
                      max: 45,
                      scale: 1,
                      transition: true,
                    }}
                  >
                    <div className="cardText img4">
                      <p>الدراسات والأبحاث</p>
                    </div>
                  </Tilt>
                </div>
              </div>
            </div>
          </div>
        </Fade>
      </div>
    </div>
  );
}
